import axios from "axios";
import React, { Component } from "react";
import PlacesAutocomplete from "../../components/common/PlacesAutocomplete";
import cookie from "react-cookies";
import Bugsnag from "@bugsnag/js";
import {
  Button,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Row,
  Col,
} from "reactstrap";
import constants from "../../Constants";
const baseURL = constants.baseURL;
class EditCustomerProfile extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    let promoCode = "";
    try {
      const queryParams = new URLSearchParams(window.location.search);
      promoCode = queryParams.get("promocode") || "";
    } catch (error) {
      Bugsnag.notify(error);
    }
    if (!cookie.load("qtcid_")) window.location.href = "/";
    const {
      firstname,
      lastname,
      email,
      mobilenumber,
      homelat,
      homelng,
      company,
      title,
      industry,
      category,
      department,
      description,
      customerid,
    } = props.profile;
    this.state = {
      isOpenMenu: false,
      loading: false,
      success: false,
      apierror: "",
      otp: "",
      id: "",
      showPasswordField: false,
      openProfile: true,
      promoCode,
      firstname,
      lastname,
      email,
      mobilenumber,
      homelat,
      homelng,
      company,
      title,
      industry,
      category,
      department,
      description,
      customerid,
    };
  }
  validStepOne() {
    const { email } = this.state;
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }

  setCustomerProfile() {
    const {
      firstname,
      lastname,
      mobilenumber,
      homelat,
      homelng,
      company,
      title,
      industry,
      category,
      department,
      description,
      customerid,
    } = this.state;
    this.setState({ loading: true, apierror: "" });
    axios
      .post(
        baseURL + "/customer-profile-update",
        {
          email: this.props.profile.email,
          mobilenumber,
          firstname,
          lastname,
          homelat,
          homelng,
          description,
          title,
          company,
          industry,
          category,
          department,
          customerid,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: cookie.load("qtcid_"),
          },
        }
      )
      .then((response) => {
        this.setState(
          {
            loading: false,

            id: response.data.id,
          },
          () => window.location.reload()
        );
      })
      .catch((e) => {
        this.setState({
          loading: false,
          apierror: "Please verify the information submitted.",
        });
      });
  }

  render() {
    return (
      <Modal isOpen={true}>
        <ModalHeader>
          <i className={"mdi mdi-account order-received"}></i>
          Customer
        </ModalHeader>
        <ModalBody>
          <>
            <FormGroup>
              <Row>
                <Col lg={6} md={6} sm={12}>
                  <Label
                    for="fullname"
                    onClick={() =>
                      this.setState({ openProfile: !this.state.openProfile })
                    }
                  >
                    Profile
                    {this.state.openProfile ? (
                      <i className="mdi mdi-arrow-up ml-2"></i>
                    ) : (
                      <i className="mdi mdi-arrow-right ml-2"></i>
                    )}
                  </Label>
                  {this.state.openProfile && (
                    <div className="profile-editor">
                      <Input
                        id="firstname"
                        name="firstname"
                        defaultValue={this.state.firstname}
                        type="text"
                        placeholder="Firstname"
                        onChange={(e) => {
                          this.setState({ firstname: e.target.value });
                        }}
                      />
                      <br />

                      <Label for="fullname">Lastname</Label>
                      <Input
                        id="lastname"
                        name="lastname"
                        defaultValue={this.state.lastname}
                        type="text"
                        onChange={(e) => {
                          this.setState({ lastname: e.target.value });
                        }}
                      />
                      <br />

                      <Label for="email">Email</Label>
                      <Input
                        id="email"
                        name="email"
                        disabled={true}
                        defaultValue={this.props.profile.email}
                        type="email"
                        onChange={(e) => {
                          this.setState({ email: e.target.value });
                        }}
                      />
                      <br />

                      <Label for="mobilenumber">Mobile number</Label>
                      <Input
                        id="mobilenumber"
                        name="mobilenumber"
                        defaultValue={this.state.mobilenumber}
                        type="tel"
                        onChange={(e) => {
                          this.setState({ mobilenumber: e.target.value });
                        }}
                      />
                      <br />

                      <Label for="description"> Your Address </Label>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={
                          "https://maps.google.com/?q=" +
                          this.state.homelat +
                          "," +
                          this.state.homelng
                        }
                        style={{ color: "lightblue" }}
                      >
                        ( view on google maps )
                      </a>
                      <PlacesAutocomplete
                        type="text"
                        className="form-control"
                        id="collection"
                        placeholder=""
                        required
                        autoComplete="new-password"
                        onPlaceSelected={(place) => {
                          if (!place?.geometry?.location?.lat()) {
                            Bugsnag.notify(
                              new Error(
                                "COLLECTION place not found: " +
                                  this.state.trucktypes
                              )
                            );
                          }
                          this.setState({
                            homelat: place?.geometry?.location?.lat(),
                            homelng: place?.geometry?.location?.lng(),
                          });
                        }}
                      />
                      <br />
                    </div>
                  )}
                </Col>
                <br />
                <br />
                <Col lg={6} md={6} sm={12}>
                  <Label
                    for="company"
                    onClick={() =>
                      this.setState({ openCompany: !this.state.openCompany })
                    }
                  >
                    Business
                    {this.state.openCompany ? (
                      <i className="mdi mdi-arrow-up ml-2"></i>
                    ) : (
                      <i className="mdi mdi-arrow-right ml-2"></i>
                    )}
                  </Label>
                  {this.state.openCompany && (
                    <div className="profile-editor">
                      <Input
                        id="company"
                        name="company"
                        defaultValue={this.state.company}
                        type="text"
                        placeholder="Name"
                        onChange={(e) => {
                          this.setState({ company: e.target.value });
                        }}
                      />
                      <br />
                      <Label for="title">Title</Label>
                      <Input
                        id="title"
                        name="title"
                        defaultValue={this.state.title}
                        type="text"
                        onChange={(e) => {
                          this.setState({ title: e.target.value });
                        }}
                      />{" "}
                      <Label for="category">Type of Goods</Label>
                      <Input
                        id="category"
                        name="category"
                        defaultValue={this.state.category}
                        type="text"
                        onChange={(e) => {
                          this.setState({ category: e.target.value });
                        }}
                      />
                      <Label for="industry">Industry</Label>
                      <Input
                        id="industry"
                        name="industry"
                        defaultValue={this.state.industry}
                        type="text"
                        onChange={(e) => {
                          this.setState({ industry: e.target.value });
                        }}
                      />
                      <Label for="department">Department</Label>
                      <Input
                        id="department"
                        name="department"
                        defaultValue={this.state.department}
                        type="text"
                        onChange={(e) => {
                          this.setState({ department: e.target.value });
                        }}
                      />
                      <Label for="description">Description</Label>
                      <Input
                        id="description"
                        name="description"
                        defaultValue={this.state.description}
                        type="textarea"
                        placeholder="Describe your services."
                        onChange={(e) => {
                          this.setState({ description: e.target.value });
                        }}
                      />
                    </div>
                  )}
                </Col>
              </Row>
              {/* <ButtonGroup>
                            <Button
                              color="primary"
                              outline
                              onClick={() =>
                                this.setState({ driverrequired: 1 })
                              }
                              active={driverrequired === 1}
                            >
                              Add Driver
                            </Button>
                            <Button
                              color="primary"
                              outline
                              onClick={() =>
                                this.setState({ driverrequired: 0 })
                              }
                              active={driverrequired === 0}
                            >
                              No Driver
                            </Button>
                          </ButtonGroup> */}
              <br />
              <p className="accept-terms">
                <Input type="checkbox" />
                Permission to use this information to secure your profile:{" "}
                <a href="https://qiktruck.co.za/terms">
                  Policies and Terms and Conditions
                </a>
              </p>

              <Button
                className="float-right mb-4"
                color="primary"
                onClick={() => {
                  this.setCustomerProfile();
                }}
                disabled={this.state.loading}
              >
                Save
                <i className="mdi mdi-arrow-right ml-2"></i>
              </Button>
            </FormGroup>
          </>
          {this.state.loading === false && this.state.apierror.length > 0 && (
            <p className="error-message">{this.state.apierror}</p>
          )}
        </ModalBody>
        <ModalFooter style={{ display: "block" }}>
          <br />
          <button
            className="open-profile xsign-out float-left"
            onClick={() => {
              cookie.remove("currentOrder");
              cookie.remove("qtcid_");
              cookie.remove("customerName");
              window.location.href = "/";
            }}
          >
            Sign out >
          </button>
          <Button
            color="secondary"
            onClick={() => {
              window.location.reload();
            }}
            className="float-right"
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default EditCustomerProfile;
